module.exports = __webpack_public_path__ + "img/NZ.7f302894.svg";